import { drawSpreadKLine } from "./draw_spread_kline"
import { DrawSVG } from "./draw_svg"
import { drawWaterMark } from "./watermark"
/**
 * 绘制上海黄金现货价格走势
 */
/**
 * K线图数据
 */
export interface KLineSourceData {
  /** 昨收 */
  pre_price: number
  /** 前一根K线的收盘价或发行价 */
  pre_kprice: number
  /** 日K总数 */
  dktotal: number
  /** 小数位数 */
  decimal: number
  /** 股票名称 */
  name: string
  /** 股票代码 */
  code: string
  /** 市场号码 */
  market: string
  /** 行情功能类型 */
  qtMiscType: number
  /** K线数据 */
  klines: Array<{
    /** 序号 */
    index: number
    /** 日期 */
    date: string
    /** 开盘价 */
    open: number
    /** 最高价 */
    high: number
    /** 最低价 */
    low: number
    /** 收盘价或者最新价 */
    close: number
    /** 成交量 */
    volume: number
    /** 成交额 */
    amount: number
    /** 振幅 */
    amplitude: number
    /** 换手 */
    huanshou: number
    /** 盘后成交量 */
    phvolume: number
    /** 盘后成交额 */
    phamount: number
    /** 涨跌额 */
    zde: number
    /** 涨跌幅 */
    zdf: string
    /** 昨结算 */
    settle: number
  }>
}

export interface CommonData {
  /** 最大价格 */
  max_price: number
  /** 中位价格1 */
  middle_price1: number
  /** 中位价格2 */
  middle_price2: number
  /** 中位价格3 */
  middle_price3: number
  /** 最小价格 */
  min_price: number
  /** 坐标轴最大价格 */
  high_price: number
  /** 坐标轴最小价格 */
  low_price: number
  /** y轴像素比例 */
  y_interval: number
  /** x轴像素比例 */
  x_interval: number
  /** 上下信息框的高度 */
  info_height: number
}

export interface KLineOptions {
  container: HTMLElement
  width: number
  height: number
  kline_data: any
  fontsize: number
  type: "sh_gold" | "gold_spread" | "hot_point"
}
export class drawGoldChart {
  svg!: DrawSVG
  container: HTMLElement
  common_data: CommonData
  gold_spread_common_data: CommonData
  calculate_data: any
  options: KLineOptions
  constructor(options: KLineOptions) {
    this.options = options
  }

  /** 获取数据并绘图 */
  async draw(type = "init") {
    if (this.options.kline_data == null) return false

    //计算绘图数据
    if (this.options.type == "gold_spread") {
      this.gold_spread_common_data = getGoldSpreadCommonData(this.options, this.options.kline_data)
    } else {
      this.common_data = countCommonData(this.options, this.options.kline_data)
    }
    //初始化svg
    this.container = document.createElement("div")
    this.container.className = "sh_gold_chart"
    this.container.style.width = this.options.width + "px"
    this.container.style.height = this.options.height + "px"
    if (type == "update") {
      this.options.container.replaceChild(this.container, this.options.container.childNodes[0])
    } else {
      this.options.container.appendChild(this.container)
    }
    this.options.container.appendChild(this.container)
    this.svg = new DrawSVG(this.container, this.options.width, this.options.height)

    if (this.options.type == "gold_spread") {
      drawSpreadKLine(this.svg, this.options.kline_data, this.gold_spread_common_data, this.options, this.container)
    } else {
      //绘图
      drawKLine(this.svg, this.options.kline_data, this.common_data, this.options, this.container)
    }
  }

  destroy() {
    this.options.container.innerHTML = ""
    this.svg && this.svg.remove()
  }
}

function drawKLine(svg: DrawSVG, data: KLineSourceData, common_data: CommonData, options: KLineOptions, container: HTMLElement) {
  let { high_price, low_price, max_price, middle_price1, middle_price2, middle_price3, min_price, y_interval, x_interval, info_height } = common_data

  let { pre_price, decimal } = data

  let { width, height, fontsize } = options

  let rect_width = x_interval - 2 > 0 ? Math.round(x_interval) : 1
  let price_gap = (high_price - low_price).toFixed(decimal)
  let ih = options.height - info_height * 2

  // 股票名称
  let stock_info_y = Number((info_height - fontsize / 2).toFixed(2))
  let stockIcon = svg.HLine(5, info_height / 2, 8)
  stockIcon.attr({ stroke: "#0065d6", "stroke-width": 2 })
  let stockName = svg.Text(20, stock_info_y)
  stockName.ele.textContent = data.name
  stockName.attr({ class: "gold-name" })

  let stockPrice = svg.Text(25 + stockName.ele.getComputedTextLength(), stock_info_y)
  
  let sh_zde = data.klines[data.klines.length - 1].zde
  let sh_date = data.klines[data.klines.length - 1].date
  let today = new Date().toISOString().substring(0,10)
  stockPrice.ele.textContent = data.klines[data.klines.length - 1].close.toFixed(decimal)
  if(sh_date != today){
    stockPrice.attr({ class: "gold-price-flat" })
  }else{
    stockPrice.attr({ class: sh_zde > 0 ? "gold-price-up" : sh_zde < 0 ? "gold-price-down" : "gold-price-flat" })
  }

  if (options.type == "sh_gold") {
    let stockHighPrice = svg.Text((window.innerWidth < 360 ? 70 : 80) + stockName.ele.getComputedTextLength(), stock_info_y)
    stockHighPrice.ele.textContent = "最高：" + high_price.toFixed(decimal)
    stockHighPrice.attr({ class: "gold-name" })

    let stockLowPrice = svg.Text((window.innerWidth < 360 ? 65 : 90) + stockName.ele.getComputedTextLength() + stockHighPrice.ele.getComputedTextLength(), stock_info_y)
    stockLowPrice.ele.textContent = "最低：" + low_price.toFixed(decimal)
    stockLowPrice.attr({ class: "gold-name" })

    if (window.innerWidth < 360) {
      stockName.attr({ "font-size": "12px" })
      stockPrice.attr({ "font-size": "12px" })
      stockHighPrice.attr({ "font-size": "12px" })
      stockLowPrice.attr({ "font-size": "12px" })
    }
  }

  let stockUnit = svg.Text(width + 7, stock_info_y)
  stockUnit.ele.textContent = "（元/克）"
  stockUnit.attr({ class: "gold-price", "text-anchor": "end","font-size": "12px"  })

  // // X轴分割线1
  // let line4 = svg.VLine(options.width / 4, info_height, options.height - info_height * 2)
  // line4.attr({ class: "gold-axis" })

  // // X轴分割线2
  // let line5 = svg.VLine(options.width / 2, info_height, options.height - info_height * 2)
  // line5.attr({ class: "gold-axis" })

  // // X轴分割线3
  // let line6 = svg.VLine((options.width / 4) * 3, info_height, options.height - info_height * 2)
  // line6.attr({ class: "gold-axis" })

  // data.klines = data.klines.slice(-options.count)

  if (options.type == "sh_gold" || options.type == "gold_spread") {
    // 上线
    let line1 = svg.HLine(0, info_height, options.width)
    line1.attr({ class: "gold-axis" })

    // 中线1
    let line2 = svg.HLine(0, options.height / 4 + info_height / 2, options.width)
    line2.attr({ class: "gold-axis" })

    // 中线2
    let line3 = svg.HLine(0, options.height / 2, options.width)
    line3.attr({ class: "gold-axis" })

    // 中线3
    let line4 = svg.HLine(0, (options.height / 4) * 3 - info_height / 2, options.width)
    line4.attr({ class: "gold-axis" })

    // 下线
    let line5 = svg.HLine(0, options.height - info_height, options.width)
    line5.attr({ class: "gold-axis" })

    //价格2
    let price2 = svg.Text(options.width, height / 4 + fontsize - 2)
    price2.attr({ class: "gold-price", "text-anchor": "end" })
    price2.ele.textContent = middle_price1.toFixed(decimal)

    //价格3
    let price3 = svg.Text(options.width, height / 2 - 2)
    price3.attr({ class: "gold-price", "text-anchor": "end" })
    price3.ele.textContent = middle_price2.toFixed(decimal)

    //价格4
    let price4 = svg.Text(options.width, (height / 4) * 3 - info_height / 2 - 1)
    price4.attr({ class: "gold-price", "text-anchor": "end" })
    price4.ele.textContent = middle_price3.toFixed(decimal)
  }

  if (options.type == "hot_point") {
    // 上线
    let line1 = svg.HLine(0, info_height, options.width)
    line1.attr({ class: "gold-axis" })

    // 中线1
    let line2 = svg.HLine(0, options.height * 0.2 + info_height / 2, options.width)
    line2.attr({ class: "gold-axis" })

    let rect1 = svg.Rect(0, info_height, options.width, (options.height - info_height) * 0.2)
    rect1.attr({ class: "gold-hot-rect1" })

    // 市场状态1
    let status1 = svg.Text(5, options.height * 0.1 + info_height)
    status1.attr({ class: "gold-price" })
    status1.ele.textContent = "沸点"

    // 中线2
    let line3 = svg.HLine(0, options.height * 0.35, options.width)
    line3.attr({ class: "gold-axis" })

    let rect2 = svg.Rect(0, options.height * 0.2 + info_height / 2, width, options.height * 0.16 - info_height / 2)
    rect2.attr({ class: "gold-hot-rect2" })

    // 市场状态2
    let status2 = svg.Text(5, options.height * 0.2 + (options.height * 0.15) / 2 + info_height / 2)
    status2.attr({ class: "gold-price" })
    status2.ele.textContent = "过热"

    // 中线3
    let line4 = svg.HLine(0, options.height / 2 - info_height / 2, options.width)
    line4.attr({ class: "gold-axis" })

    let rect3 = svg.Rect(0, options.height * 0.35, width, options.height * 0.16 - info_height / 2)
    rect3.attr({ class: "gold-hot-rect3" })

    // 市场状态3
    let status3 = svg.Text(5, options.height * 0.35 + (options.height * 0.15) / 2)
    status3.attr({ class: "gold-price" })
    status3.ele.textContent = "微热"

    // 中线4
    let line5 = svg.HLine(0, options.height * 0.65 - info_height / 2, options.width)
    line5.attr({ class: "gold-axis" })

    let rect4 = svg.Rect(0, options.height / 2 - info_height / 2, width, options.height * 0.16)
    rect4.attr({ class: "gold-hot-rect4" })

    // 市场状态4
    let status4 = svg.Text(5, options.height * 0.5 + (options.height * 0.15) / 2 - fontsize / 2)
    status4.attr({ class: "gold-price" })
    status4.ele.textContent = "微冷"

    // 中线5
    let line6 = svg.HLine(0, options.height * 0.8 - info_height / 2, options.width)
    line6.attr({ class: "gold-axis" })

    let rect5 = svg.Rect(0, options.height * 0.65 - info_height / 2, width, options.height * 0.16)
    rect5.attr({ class: "gold-hot-rect5" })

    // 市场状态5
    let status5 = svg.Text(5, options.height * 0.65 + (options.height * 0.15) / 2 - fontsize / 2)
    status5.attr({ class: "gold-price" })
    status5.ele.textContent = "过冷"

    // 下线
    let line7 = svg.HLine(0, options.height - info_height, options.width)
    line7.attr({ class: "gold-axis" })

    let rect6 = svg.Rect(0, options.height * 0.8 - info_height / 2, width, options.height * 0.21 - info_height / 2)
    rect6.attr({ class: "gold-hot-rect6" })

    // 市场状态6
    let status6 = svg.Text(5, options.height * 0.8 + (options.height * 0.2) / 2 - info_height / 2)
    status6.attr({ class: "gold-price" })
    status6.ele.textContent = "冰点"
  }

  //价格1
  let price1 = svg.Text(options.width, info_height + fontsize)
  price1.attr({ class: "gold-price", "text-anchor": "end" })
  price1.ele.textContent = high_price.toFixed(decimal)

  //价格5
  let price5 = svg.Text(options.width, options.height - info_height - 2)
  price5.attr({ class: "gold-price", "text-anchor": "end" })
  price5.ele.textContent = low_price.toFixed(decimal)

  let start_date = data?.klines?.[0]?.date
  let middle_date = data?.klines?.length > 2 ? data?.klines?.[Math.floor(data.klines.length / 2)]?.date : null
  let end_date = data?.klines?.length > 2 ? data?.klines?.[data.klines.length - 1]?.date : null
  let kline_nums = data.klines.length

  //开始日期
  if (start_date) {
    let date1 = svg.Text(3, options.height - (info_height - fontsize) / 2 - 1)
    date1.ele.textContent = start_date
    date1.attr({ "text-anchor": "start", class: "gold-price" })
  }
  // 中间日期
  if (middle_date) {
    let date2 = svg.Text(((x_interval - rect_width) / 2 + x_interval * kline_nums - 32) / 2 - 10, options.height - (info_height - fontsize) / 2 - 1)
    date2.ele.textContent = middle_date
    date2.attr({ class: "gold-price" })
  }
  //结束日期
  if (end_date) {
    let date3 = svg.Text((x_interval - rect_width) / 2 + x_interval * kline_nums, options.height - (info_height - fontsize) / 2 - 1)
    date3.ele.textContent = end_date
    date3.attr({ "text-anchor": "end", class: "gold-price" })
  }

  let price_path_d = [] as Array<{ x: number; y: number }>
  data.klines.map(function (v: any, index) {
    if (v.close != null) {
      price_path_d.push({ x: x_interval / 2 + index * x_interval, y: Math.abs((Number(high_price.toFixed(decimal)) - v.close) / Number(price_gap)) * ih })
    }
  })
  let price_path = svg.Path(price_path_d)
  price_path.attr({
    class: "gold_path",
    transform: "translate(0," + (info_height + 1) + ")",
  })

  //水印
  drawWaterMark(svg.ele, (options.width - 160) / 2, (options.height - 60) / 2)

  //外框
  let outborder = svg.Rect(0, 0, options.width, options.height)
  outborder.attr({ class: "out_border" })
}

/** 处理K线数据接口数据 */
export function dealData(source_data: any): null | KLineSourceData {
  try {
    if (source_data.data == null) return null
    let closePriceArr: Array<number> = []
    let back: KLineSourceData = {
      pre_price: source_data.data.prePrice,
      pre_kprice: source_data.data.preKPrice,
      dktotal: source_data.data.dktotal,
      decimal: source_data.data.decimal,
      name: source_data.data.name,
      code: source_data.data.code,
      market: source_data.data.market.toString(),
      qtMiscType: source_data.data.qtMiscType,
      klines: source_data.data.klines.map((v: string, index: number) => {
        let tempobj = v.split(",")
        closePriceArr.push(parseFloat(tempobj[2]))

        return {
          index: index,
          date: tempobj[0],
          open: parseFloat(tempobj[1]) == 0 ? parseFloat(tempobj[2]) : parseFloat(tempobj[1]),
          high: parseFloat(tempobj[3]),
          low: parseFloat(tempobj[4]),
          close: parseFloat(tempobj[2]),
          volume: parseInt(tempobj[5]),
          amount: parseFloat(tempobj[6]),
          amplitude: parseFloat(tempobj[7]),
          huanshou: parseFloat(tempobj[10]),
          phvolume: parseInt(tempobj[11]),
          phamount: parseFloat(tempobj[12]),
          zde: parseFloat(tempobj[9]),
          zdf: formatNumToFixed(parseFloat(tempobj[8]), 0, 2, "", "%"),
          // 昨结
          settle: parseFloat(tempobj[14]),
        }
      }),
    }

    return back
  } catch (error) {
    console.error(error)
  }
  return null
}

export function countCommonData(options: KLineOptions, data: KLineSourceData): any {
  const kline_count = data?.klines?.length
  let first_data = data.klines.slice(-kline_count)?.[0]
  let max_price = first_data?.high ?? 0
  let min_price = first_data?.low ?? 0
  data.klines.slice(-kline_count).forEach(function (v: any) {
    if (v.high > max_price) max_price = v.high
    if (v.low < min_price) min_price = v.low
  })

  let middle_price2 = (max_price + min_price) / 2
  let middle_price1 = (max_price + middle_price2) / 2 + 1
  let middle_price3 = (min_price + middle_price2) / 2

  let price_span = Math.max(Math.abs(max_price - middle_price2), Math.abs(min_price - middle_price2))
  // 平线 上下限浮动5%
  if (price_span == 0) {
    price_span = Math.abs(middle_price2 * 0.05)
  }

  let high_price = Math.round((middle_price2 + price_span) * Math.pow(10, data.decimal)) / Math.pow(10, data.decimal)
  let low_price = Math.round((middle_price2 - price_span) * Math.pow(10, data.decimal)) / Math.pow(10, data.decimal)

  let info_height = options.fontsize * 1.8
  let x_interval = options.width / kline_count
  let y_interval = (options.height - info_height * 2 - 2) / Math.abs(high_price - low_price)

  return {
    max_price,
    min_price,
    high_price,
    low_price,
    middle_price1,
    middle_price2,
    middle_price3,
    y_interval,
    x_interval,
    info_height,
  }
}

export function countCalculateData(options: KLineOptions, data: any, is_spread = false): any {
  const kline_count = data?.klines?.length
  if (kline_count) {
    let first_data = data.klines.slice(-kline_count)?.[0]
    let max_price = Number(first_data?.close) ?? 0
    let min_price = Number(first_data?.close) ?? 0
    data.klines.slice(-kline_count).forEach(function (v: any) {
      if (Number(v.close) > max_price) max_price = v.close
      if (Number(v.close) < min_price) min_price = v.close
    })

    let middle_price2 = (Number(max_price) + Number(min_price)) / 2
    let middle_price1 = (Number(max_price) + Number(middle_price2)) / 2
    let middle_price3 = (Number(min_price) + Number(middle_price2)) / 2
    let price_span = Math.max(Math.abs(max_price - middle_price2), Math.abs(min_price - middle_price2))

    // 平线 上下限浮动5%
    if (price_span == 0) {
      price_span = Math.abs(middle_price2 * 0.05)
    }
    if (is_spread) {
      price_span = Math.abs(middle_price2)
    }

    let high_price = Math.round((Number(max_price) + price_span) * Math.pow(10, data.decimal)) / Math.pow(10, data.decimal)
    let low_price = Math.round((Number(min_price) - price_span) * Math.pow(10, data.decimal)) / Math.pow(10, data.decimal)

    let info_height = options.fontsize * 1.8
    let x_interval = options.width / kline_count
    let y_interval = (options.height - info_height * 2 - 2) / Math.abs(high_price - low_price)

    return {
      max_price,
      min_price,
      high_price,
      low_price,
      middle_price1,
      middle_price2,
      middle_price3,
      y_interval,
      x_interval,
      info_height,
    }
  }
}

export function getGoldSpreadCommonData(options: KLineOptions, data: any): any {
  const { SHAU_Data, XAU_Data, Gold_Spread_Data } = data
  let sh_common_data = countCommonData(options, SHAU_Data)
  let x_common_data = countCalculateData(options, XAU_Data)
  let spread_common_data = countCalculateData(options, Gold_Spread_Data, true)

  let gold_common_data: any = {}
  if (sh_common_data.max_price >= x_common_data.max_price) {
    gold_common_data.gold_max_price = sh_common_data.max_price
  } else {
    gold_common_data.gold_max_price = x_common_data.max_price
  }
  if (sh_common_data.min_price <= x_common_data.min_price) {
    gold_common_data.gold_min_price = x_common_data.min_price
  } else {
    gold_common_data.gold_min_price = x_common_data.min_price
  }
  let middle_price2 = (Number(gold_common_data.gold_max_price) + Number(gold_common_data.gold_min_price)) / 2
  let middle_price1 = (Number(gold_common_data.gold_max_price) + Number(middle_price2)) / 2
  let middle_price3 = (Number(gold_common_data.gold_min_price) + Number(middle_price2)) / 2

  const { gold_max_price, gold_min_price } = gold_common_data
  let price_span = Math.max(Math.abs(gold_max_price - middle_price2), Math.abs(gold_min_price - middle_price2))
  // 平线 上下限浮动5%
  if (price_span == 0) {
    price_span = Math.abs(middle_price2 * 0.05)
  }

  let high_price = Math.round((middle_price2 + price_span) * Math.pow(10, 2)) / Math.pow(10, 2)
  let low_price = Math.round((middle_price2 - price_span) * Math.pow(10, 2)) / Math.pow(10, 2)

  let info_height = options.fontsize * 1.8
  let y_interval = (options.height - info_height * 2 - 2) / Math.abs(high_price - low_price)

  gold_common_data = {
    y_interval,
    info_height,
    gold_high_price: high_price,
    gold_low_price: low_price,
    gold_middle_price1: middle_price1,
    gold_middle_price2: middle_price2,
    gold_middle_price3: middle_price3,
    x_interval: sh_common_data.x_interval,
  }
  return {
    gold_common_data,
    spread_common_data,
  }
}

export function getTimeString(input: any) {
  if (input) {
    let inputstr = input.toString()
    if (inputstr?.length > 3) {
      return inputstr.substring(inputstr.length - 4, inputstr.length - 2) + ":" + inputstr.substring(inputstr.length - 2, inputstr.length)
    }
  }

  return null
}

export function formatNumToFixed(value: any, rate: number, tofixed: number, prefix = "", suffix = "") {
  if (value == "-" || value == undefined || isNaN(value)) return "-"
  let num = Number(value)
  let r = Number(rate)
  let temp = Math.pow(10, r)

  if (num) {
    return prefix + (num / temp).toFixed(tofixed) + suffix
  } else {
    return prefix + num.toFixed(tofixed) + suffix
  }
}
